import { render } from "./CustomDialogComponent.vue?vue&type=template&id=373a5e54&scoped=true&ts=true"
import script from "./CustomDialogComponent.vue?vue&type=script&lang=ts"
export * from "./CustomDialogComponent.vue?vue&type=script&lang=ts"

import "./CustomDialogComponent.vue?vue&type=style&index=0&id=373a5e54&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373a5e54"]])

export default __exports__